import type { EntityConfig } from "../hooks/useEntity";

export const transcriptEntityConfig: EntityConfig = {
  name: "Transcript",
  orderBy: "updated_at DESC",
  properties: {
    title: { type: "string", description: "Transcript title (typically audio file name)" },
    transcript: { type: "string", description: "Full transcript text" },
    summary: { type: "string", description: "AI-generated summary of transcript/document" },
    segments: { type: "string", description: "Array of timestamped segments (JSON)" },
    questions: { type: "string", description: "Array of questions (JSON)" },
    answers: { type: "string", description: "Array of answers with chatHistory (JSON)" },
    qaPairs: { type: "string", description: "Array of Q&A pairs (JSON)" },
    audioFileName: { type: "string", description: "Original audio/video file name" },
    audioDatabaseId: { type: "string", description: "IndexedDB recording ID for playback" },
    questionsFileName: { type: "string", description: "Original questions file or Manual" },
    mode: { type: "string", description: "audio | text | document" },
    documentType: { type: "string", description: "pdf | docx | txt (if document mode)" },
    userId: { type: "integer", description: "Owner user id" },
  },
  required: ["title", "transcript"],
};
